module.exports = __webpack_public_path__ + "img/lover of sweets.d608ccee.png";